import { createAsyncThunk } from "@reduxjs/toolkit";
import { useGetDataToken } from "../../../hooks/useGetData";
import notify from "../../../Components/Utilities/notify";
import { useUpdateData } from "../../../hooks/useUpdateData";
import { useInsertData } from "../../../hooks/useInsertData";



export const getAllServices = createAsyncThunk(
    "/usersSlice/getAllServices",
    async ({branchId, Category}) => {
        try {
            const response = await useGetDataToken(`/api/v1/services?branchId=${branchId}&catNum=${Category}`);
            return response;
        } catch (error) {
            if (error.message == "Network Error")
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
            else
            return notify(error.response.data,"error");
        }
    }
);
export const getAllServiceproviders = createAsyncThunk(
    "/usersSlice/getAllServiceproviders",
    async ({serviceId}) => {
        try {
            const response = await useGetDataToken(`/api/v1/employees/employeesForService?serviceId=${serviceId}`);
            return response;
        } catch (error) {
            if (error.message == "Network Error")
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
            else
            return notify(error.response.data,"error");
        }
    }
);


